import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, Navigate } from 'react-router-dom'
import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import style from './InsuredPersonSelection.module.scss'
import CircleSmile from 'components/assets/icons/CircleSmile'
import SquareSmile from 'components/assets/icons/SquareSmile'
import Card from 'components/common/Card/Card'
import PageTitle from 'components/common/PageTitle/PageTitle'
import PageSubtitle from 'components/common/PageSubtitle/PageSubtitle'

const InsuredPersonSelection = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { contract, claimsPersonConcerned, claimsClientInfo } = state || {}
  const { color, colabelNeutralMid } = useContext(ClientContext)

  const onSelectInsuredPerson = isSomeoneElse => {
    navigate('../contacts', { state: { ...state, contract, step: 2, isSomeoneElse } })
  }

  return claimsPersonConcerned === false || claimsClientInfo === false
  ? <Navigate
      to={'/claims/new/' + (claimsClientInfo === false ? 'circumstances' : 'contacts')}
      state={
        {
          ...state,
          step: claimsClientInfo === false ? 3 : 2,
          claim: claimsClientInfo === false && {
            firstname: contract.firstname,
            lastname: contract.lastname,
            birthdate: contract.birthdate,
            placeOfBirth: contract.placeOfBirth,
            countryOfBirth: contract.countryOfBirth,
            address: contract.address,
            zipcode: contract.zipcode,
            city: contract.city,
            country: contract.country,
            additionalAddress: contract.additionalAddress,
            email: contract.email,
            phone: contract.phone
          }
        }
      }
      replace
    />
  : (
    <>
      <PageTitle text={t('claim:applySteps.insuredPerson.title')} />
      <PageSubtitle text={t('claim:applySteps.insuredPerson.subtitle')} />

      <div className={style.options}>
        <Card
          className={style.option}
          content={
            <div className={style['option-content']}>
              <CircleSmile styles={color && {fill: colabelNeutralMid}} />
              <p>{t('claim:applySteps.insuredPerson.you')}</p>
            </div>
          }
          inactive={contract.cancelation}
          isCentered
          onClick={() => onSelectInsuredPerson()}
        />
        <Card
          className={style.option}
          content={
            <div className={style['option-content']}>
              <SquareSmile styles={color && {fill: colabelNeutralMid}} />
              <p>{t('claim:applySteps.insuredPerson.someoneElse')}</p>
            </div>
          }
          inactive={contract.cancelation}
          isCentered
          onClick={() => onSelectInsuredPerson(true)}
        />
      </div>
    </>
  )
}

export default InsuredPersonSelection
